import { getCookie } from "./firebase/auth";

const SERVER_URL =
  process.env.REACT_APP_SERVER_URL || "http://127.0.0.1:8000";

const getGptResponse = async (requestBody) => {
  try {
    const response = await fetch(`${SERVER_URL}/llm/openai`, {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(requestBody),
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${await getCookie('token')}`,
      },
    });

    if (!response.ok) {
      throw new Error("Request failed with status " + response.status);
    }
    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

export default getGptResponse;
